import { useLang } from "../../context/LanguageContext";
import { Anchor, ArrowUpRight } from "lucide-react";

export const FeaturedUseCase = () => {
  const { t } = useLang();
  return (
    <section data-testid="featured-section" className="py-24 lg:py-32 border-b border-[#0B1F3A]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-6 lg:gap-10 items-stretch">
          <div className="col-span-12 lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#D4AF37]" />
              <span className="overline">{t.featured.eyebrow}</span>
            </div>
            <h2 className="font-display text-3xl lg:text-4xl font-light text-[#0B1F3A] leading-tight tracking-tight">
              {t.featured.title}
            </h2>
            <p className="mt-6 text-base lg:text-lg text-[#0B1F3A]/75 leading-relaxed">{t.featured.sub}</p>

            <div className="mt-10 grid grid-cols-2 gap-3">
              {t.featured.capabilities.map((c, i) => (
                <div
                  key={c}
                  data-testid={`featured-cap-${i}`}
                  className="border border-[#0B1F3A]/15 px-4 py-3 hover:border-[#D4AF37] transition-colors group"
                >
                  <div className="text-[10px] tracking-widest text-[#0B1F3A]/40 font-mono">CAP · {String(i + 1).padStart(2, "0")}</div>
                  <div className="mt-1.5 text-sm font-semibold text-[#0B1F3A] flex items-center justify-between">
                    {c}
                    <ArrowUpRight size={14} strokeWidth={1.5} className="text-[#0B1F3A]/30 group-hover:text-[#D4AF37] transition-colors" />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-span-12 lg:col-span-6 border border-[#0B1F3A]/15 bg-[#0B1F3A] text-white relative overflow-hidden flex flex-col">
            <div className="px-6 py-4 border-b border-white/15 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Anchor size={14} strokeWidth={1.5} className="text-[#D4AF37]" />
                <span className="text-[10px] tracking-[0.2em] uppercase text-white/80 font-semibold">Port Operating System</span>
              </div>
              <span className="text-[10px] tracking-widest text-[#D4AF37] font-semibold">REF-PORT</span>
            </div>

            <svg viewBox="0 0 500 380" className="w-full flex-1">
              <defs>
                <pattern id="portgrid" width="25" height="25" patternUnits="userSpaceOnUse">
                  <path d="M 25 0 L 0 0 0 25" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="1" />
                </pattern>
              </defs>
              <rect width="500" height="380" fill="url(#portgrid)" />

              {/* lanes */}
              <g stroke="rgba(255,255,255,0.18)" strokeWidth="1">
                <line x1="40" y1="80" x2="460" y2="80" />
                <line x1="40" y1="170" x2="460" y2="170" />
                <line x1="40" y1="260" x2="460" y2="260" />
              </g>

              {/* lane labels */}
              {[
                { y: 60, label: "PASSENGER" },
                { y: 150, label: "WORKFORCE" },
                { y: 240, label: "COMMERCIAL" },
                { y: 330, label: "INTELLIGENCE" },
              ].map((l) => (
                <text key={l.label} x="40" y={l.y} fontSize="9" fontFamily="IBM Plex Sans" fontWeight="600" fill="#D4AF37" letterSpacing="1.8">
                  {l.label}
                </text>
              ))}

              {/* nodes */}
              {[
                { x: 60, y: 92, l: "Pre-trip" },
                { x: 170, y: 92, l: "Arrival" },
                { x: 280, y: 92, l: "Boarding" },
                { x: 390, y: 92, l: "Onboard" },
                { x: 60, y: 182, l: "Shift" },
                { x: 170, y: 182, l: "Ops" },
                { x: 280, y: 182, l: "Safety" },
                { x: 390, y: 182, l: "Training" },
                { x: 60, y: 272, l: "Parking" },
                { x: 170, y: 272, l: "Retail" },
                { x: 280, y: 272, l: "Hotel" },
                { x: 390, y: 272, l: "Ads" },
              ].map((n, i) => (
                <g key={i}>
                  <rect x={n.x} y={n.y} width="76" height="26" fill="#0B1F3A" stroke="rgba(255,255,255,0.4)" strokeWidth="1" />
                  <text x={n.x + 38} y={n.y + 17} textAnchor="middle" fontSize="9" fontFamily="Inter" fill="#FFFFFF" letterSpacing="0.6">{n.l}</text>
                </g>
              ))}

              {/* AI layer */}
              <rect x="40" y="320" width="420" height="34" fill="#D4AF37" />
              <text x="250" y="341" textAnchor="middle" fontSize="11" fontFamily="IBM Plex Sans" fontWeight="600" fill="#0B1F3A" letterSpacing="1.5">
                DATA INTELLIGENCE · AI CONCIERGE
              </text>

              {/* flow lines */}
              <g stroke="#D4AF37" strokeWidth="1.5" fill="none" className="svg-flow">
                <line x1="136" y1="105" x2="170" y2="105" />
                <line x1="246" y1="105" x2="280" y2="105" />
                <line x1="356" y1="105" x2="390" y2="105" />
              </g>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};
